"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _DownloadLinkBox = _interopRequireDefault(require("../../../SIA-WEBSITE/DownloadLinkBox/DownloadLinkBox"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.sia-event-occurrence .event_date_times {\n  width: 100%; }\n\n.sia-event-occurrence .date_times {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  gap: 16px; }\n";
  const fileName = "EventDateTimes_EventDateTimes";
  const element = document.querySelector("style[data-sass-component='EventDateTimes_EventDateTimes']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const getDateLocTime = (date_time, translate) => {
  const date = date_time.date;
  const formattedDate = date.split('-').reverse().join('.');
  const location = date_time?.event_generic_location?.name || translate('cms.agenda.event_occurrence.unknown_location');
  const start = date_time?.start || '';
  const end = date_time?.end ? `- ${date_time?.end}` : '';
  const time = start ? `${start.replace(':00', '')} ${end.replace(':00', '')} ${translate('cms.agenda.event_occurrence.hour')}` : translate('cms.agenda.event_occurrence.unknown_time');
  return `${formattedDate} / ${location} / ${time}`;
};
const Location = _ref => {
  let {
    location,
    lang
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "location sia-text-10"
  }, /*#__PURE__*/_react.default.createElement("p", null, location?.name), /*#__PURE__*/_react.default.createElement("p", null, location?.address_line_1), /*#__PURE__*/_react.default.createElement("p", null, location?.address_line_2), /*#__PURE__*/_react.default.createElement("p", null, location?.zip, " ", location?.city), location?.phone && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("a", {
    href: 'tel:' + location?.phone
  }, location?.phone), " ", /*#__PURE__*/_react.default.createElement("br", null)), location?.location_email && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("a", {
    href: 'mailto:' + location?.location_email
  }, location?.location_email), /*#__PURE__*/_react.default.createElement("br", null)), location?.location_website && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("a", {
    href: location?.location_website?.original_url
  }, location?.location_website?.original_url), /*#__PURE__*/_react.default.createElement("br", null)), location?.maps_url && /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-padding-01-top"
  }, /*#__PURE__*/_react.default.createElement(_DownloadLinkBox.default, {
    items: [{
      link: {
        original_url: location?.maps_url,
        url: location?.maps_url,
        title: 'Map'
      }
    }],
    lang: lang
  })));
};
const EventDateTimes = _ref2 => {
  let {
    date_times,
    translate,
    lang
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "event_date_times"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "top sia-text-07"
  }, translate('cms.agenda.event_occurrence.date_loc_time')), /*#__PURE__*/_react.default.createElement("div", {
    className: "date_times"
  }, date_times?.map(datetime => /*#__PURE__*/_react.default.createElement("div", {
    key: datetime.id
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "bottom sia-text-03"
  }, getDateLocTime(datetime, translate)), datetime.event_location?.length > 0 && /*#__PURE__*/_react.default.createElement(Location, {
    location: datetime.event_location[0],
    lang: lang
  })))));
};
var _default = exports.default = EventDateTimes;